<script>
    export default function(props = {}) {
        let value;

        return {
            // This cannot be called "value" otherwise it prevents a data-bound value with the same name.
            get _value() {
                // If the "value" property is a getter then it is referencing an outer variable so we should always get it.
                return value = value === undefined || Object.getOwnPropertyDescriptor(props, 'value').get !== undefined ? props.value : value;
            },
            set _value(val) {
                value = val;

                this.$refs.root.dispatchEvent(new CustomEvent('update:value', { detail: value }));

                // Update the value and invoke the change event. Note: This must be the change event to not interfere with the Vue.js input event.
                this.$refs.value.value = value ?? '';
                this.$refs.value.dispatchEvent(new Event('change', { bubbles: true }));
            }
        };
    }
</script>